// extracted by mini-css-extract-plugin
module.exports = {"container":"question-stats_container__1CqUZ","vote":"question-stats_vote__1We3m","answer":"question-stats_answer__37V1J","view":"question-stats_view__265tn"};